import useShowSuccess from 'hooks/useShowSuccess'
import { useUpdatePartMutation, UpdatePartMutationVariables } from '../../../../graphql'

export default function useUpdatePartHandler() {
	const [ updatePart ] = useUpdatePartMutation()
	const showSuccess = useShowSuccess()

	return async( { partId, partNumber, providerId, description, upc, standardPrice, msrp, productClassId }: UpdatePartMutationVariables ) => {
		await updatePart( {
			variables: {
				partId,
				partNumber,
				providerId,
				description,
				upc,
				standardPrice,
				msrp,
				productClassId,
			},
		} )
		showSuccess( `updatePartSuccess${Date.now()}`, 'Successfully updated product!' )
	}
}
